import { Injectable } from '@angular/core'
import Dexie from 'dexie'

const LEGACY_DB_NAMES = ['HuntDatabase', 'RouteHistoryDB', 'ErrorLogDB']

/**
 * One-shot deletion of legacy IndexedDB databases that are no longer used.
 * Safe to remove once all returning users have loaded the app at least once.
 */
@Injectable({ providedIn: 'root' })
export class IdbPurgeService {
  public async runPurge(): Promise<void> {
    for (const dbName of LEGACY_DB_NAMES) {
      try {
        await Dexie.delete(dbName)
      } catch (error) {
        console.warn(`[IDB Purge] Failed to delete DB "${dbName}"`, error)
      }
    }
  }
}
